import styled from 'styled-components';

export const UnitPriceWrapper = styled.div`
  display: flex;
  font-size: 0.625rem;
  font-weight: 400;
`;
